// This is needed for poly2tri to work in browser
if (typeof global === 'undefined') {
  (window as any).global = window;
}
